<template>
  <div>
    <b-modal v-model="modalOpen" :component="getSubmissionComponent()" :events="{save: handleSubmissionUpdate}" :props="{ 'submission': currentSubmission, 'patientId': currentSubmission?.patient_id, 'patientMonitorId': currentSubmission?.patient_monitor_id, 'viewOnly': currentSubmission && !(this.currentSubmission?.form?.can_update && this.currentSubmission?.status === 'in_progress') }" :can-cancel="true"></b-modal>
    <div v-if="data.length > 0" class="submissions">
      <div class="submission_item" :key="item.id" v-for="item in data" @click="viewSubmission(item)" :class="{'is-completed': item.status === 'completed'}">
        <div>
          <div class="submission__header">
            <div class="submission__title">{{ item.form.name }}</div>
          </div>
          <div class="submission__footer">
            <div>
              <span class="key">Filled by</span>
              <span>{{ item.filled_by.name }}</span>
            </div>
            <div>
              <span class="key">@</span>
              <span>{{ $helpers.formatDate(item.created_at) }}</span>
            </div>
          </div>
        </div>
        <div class="submission__status">
            <span class="tag is-small" :class="item.status === 'completed' || !item.form.can_update ? 'is-success' : 'is-info'">
              {{ item.status === 'completed' || !item.form.can_update ? 'Completed' : 'In Progress' }}
            </span>
          </div>
      </div>
    </div>
    <p v-else class="no-data-message">No forms were submitted for this patient</p>
  </div>
</template>

<script>
import FormFill from "@/components/form_builder/FormFill";

export default {
name: "FormSubmissionsList",
  props: {
    data: {
      type: Array,
      default: () => { return [] },
    }
  },
  methods: {
    viewSubmission(submission) {
      this.modalOpen = true
      this.currentSubmission = submission
    },
    getSubmissionComponent() {
      return FormFill
    },
    handleSubmissionUpdate() {
      this.modalOpen = false
      this.$emit('updated')
    }
  },
  data() {
    return {
      modalOpen: false,
      currentSubmission: null
    }
  }
}
</script>
<style lang="scss" scoped>
.submissions {
  display: flex;
  flex-direction: column;
}
.submission_item {
  padding: 10px 10px 10px;
  transition: all 0.1s lienar;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  &:not(:last-child) {
    border-bottom: 1px solid $background-level-0;
  }
  &:hover {
    cursor: pointer;
    border-radius: 5px;
    background: $background-level-0;
  }
}
.submission__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
  position: relative;
}
.submission__title {
  font-size: 14px;
  line-height: 18px;  
}
.key {
  color: $secondary-text-color;
  font-size: 11px;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 1px;
  padding-right: 5px;
}
.submission__footer {
  display: flex;
  font-size: 13px;
  > div {
    padding-right: 5px;
    display: flex;
    align-items: center;
  }
}
</style>
